import { PureComponent } from 'react'
import ReactCrop from 'react-image-crop'
import 'react-image-crop/dist/ReactCrop.css'
import Upload from 'src/components/upload'
class CropImage extends PureComponent {
  state = {
    src: null,
    crop: {
      unit: '%',
      width: 50,
      aspect: 1,
    },
  }

  onSelectFile = (acceptedFiles) => {
    if (acceptedFiles && acceptedFiles.length > 0) {
      const reader = new FileReader()
      reader.addEventListener('load', () =>
        this.setState({ src: reader.result }),
      )
      reader.readAsDataURL(acceptedFiles[0])
    }
  }

  // If you setState the crop in here you should return false.
  onImageLoaded = (image) => {
    this.imageRef = image
  }

  onCropComplete = (crop) => {
    this.makeClientCrop(crop)
  }

  onCropChange = (crop, percentCrop) => {
    // You could also use percentCrop:
    // this.setState({ crop: percentCrop });
    this.setState({ crop })
  }

  handleSave = () => {
    if (this.props.onApply) {
      this.props.onApply(this.state.croppedImageUrl)
    }
  }

  async makeClientCrop(crop) {
    if (this.imageRef && crop.width && crop.height) {
      const croppedImageUrl = await this.getCroppedImg(
        this.imageRef,
        crop,
        'newFile.jpeg',
      )
      this.setState({ croppedImageUrl })
      if (this.props.onChange) {
        this.props.onChange(croppedImageUrl)
      }
    }
  }

  getCroppedImg(image, crop, fileName) {
    const canvas = document.createElement('canvas')
    const scaleX = image.naturalWidth / image.width
    const scaleY = image.naturalHeight / image.height
    canvas.width = crop.width
    canvas.height = crop.height
    const ctx = canvas.getContext('2d')

    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width,
      crop.height,
    )

    // As Base64 string
    const base64Image = canvas.toDataURL('image/jpeg')
    return base64Image

    // return new Promise((resolve, reject) => {
    //   canvas.toBlob(blob => {
    //     if (!blob) {
    //       //reject(new Error('Canvas is empty'));
    //       console.error('Canvas is empty');
    //       return;
    //     }
    //     blob.name = fileName;
    //     window.URL.revokeObjectURL(this.fileUrl);
    //     this.fileUrl = window.URL.createObjectURL(blob);
    //     resolve(this.fileUrl);
    //   }, 'image/jpeg');
    // });
  }

  handleRemove = (e) => {
    e.preventDefault()
    this.setState({ src: null })
  }

  render() {
    const { crop, croppedImageUrl, src } = this.state

    return src ? (
      <div className="row">
        <div className="col-lg-6">
          <ReactCrop
            src={src}
            crop={crop}
            ruleOfThirds
            onImageLoaded={this.onImageLoaded}
            onComplete={this.onCropComplete}
            onChange={this.onCropChange}
          />
          {/* <button onClick={this.handleSave} className="primary-btn" type="button">Save</button> */}
          <div>
            <a className="link" onClick={this.handleRemove} href="#">
              Remove
            </a>
          </div>
        </div>
        <div className="col-lg-6">
          {croppedImageUrl && (
            <div style={{ display: 'block' }}>
              <img
                alt="Crop"
                style={{ maxWidth: '100%' }}
                src={croppedImageUrl}
              />
            </div>
          )}
        </div>
      </div>
    ) : (
      <Upload accept="image/*" onChange={this.onSelectFile} />
    )
  }
}

export default CropImage
